import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PagedListResult } from "../models/paged-list-result.model";
import { Position } from "../models/position.model";
import { Search } from "../models/search.model";
import { DefaultDataService } from "./default-data.service";
import { StateService } from "./state.service";
import { Result } from "../models/general/result.model";

@Injectable({
    providedIn: 'root'
})
export class PositionService extends DefaultDataService<Position> {
    
    constructor(
        http: HttpClient, 
        stateService: StateService,
    ) 
    {
        super(http, stateService);
        this.controllerName = 'position';
    }
    
    getListForCompany = (options?: Search): Observable<PagedListResult<Position>> => {
        return this.post<PagedListResult<Position>>(`/api/${this.controllerName}/list-for-company`, options, {headers: {'X-Skip-Interceptor':'1'}} );
    }

    GetListForCommonAndCurrentCompany = (options?: Search): Observable<PagedListResult<Position>> => {
        return this.post<PagedListResult<Position>>(`/api/${this.controllerName}/list-all`, options, {headers: {'X-Skip-Interceptor':'1'}} );
    }

    getFirst(): Observable<Position> {
        return this.get<Position>(`/api/${this.controllerName}/first`);
    }

    create(model: Position): Observable<Position> {
        return this.post<Position>(`/api/${this.controllerName}`, model);
    }

    update(model: Position): Observable<Position> {
        return this.put<Position>(`/api/${this.controllerName}`, model);
    }

    remove(id: number): Observable<Position> {
        return this.delete<Position>(`/api/${this.controllerName}/${id}`);
    }

    copy(id: number): Observable<Result<number>> {
        return this.get<Result<number>>(`/api/${this.controllerName}/copy/${id}`);
    }

}